import { FC, useState } from "react"
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material"
import { InlineCode } from "@/core/components"
import { useExportClientSessionMutation } from "../../store"
import { getApiErrorMessage } from "@/core/utils"

interface IProps {
  clientId: string
}

/** Секция экспорта сессии — для ClientMeView (авторизованный клиент). */
export const SessionExportSection: FC<IProps> = ({ clientId }) => {
  const [exportSession, exportState] = useExportClientSessionMutation()
  const [exported, setExported] = useState<string | null>(null)
  const [exportError, setExportError] = useState<string | null>(null)

  const handleExport = async () => {
    setExportError(null)
    setExported(null)
    try {
      const res = await exportSession({ id: clientId }).unwrap()
      setExported(res.session)
    } catch (e) {
      setExportError(getApiErrorMessage(e))
    }
  }

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle1">Экспорт сессии</Typography>
      <Button
        variant="outlined"
        onClick={handleExport}
        disabled={exportState.isLoading}
      >
        Экспортировать сессию
        {exportState.isLoading && <CircularProgress size={16} sx={{ ml: 1 }} />}
      </Button>
      {exportError && <Alert severity="error">{exportError}</Alert>}
      {exported && (
        <Stack spacing={1}>
          <Alert severity="warning">
            Строка сессии — секрет, относитесь к ней как к паролю. Не
            передавайте третьим лицам.
          </Alert>
          <Box sx={{ maxWidth: "100%" }}>
            <InlineCode
              text={exported}
              buttonProps={{
                sx: {
                  maxWidth: "100%",
                  overflowWrap: "anywhere",
                  justifyContent: "flex-start",
                  textAlign: "left",
                },
              }}
            />
          </Box>
        </Stack>
      )}
    </Stack>
  )
}
